var _path, _path2, _path3, _circle, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5273.1 2400.1v-2c0-2.8-5-4-9.7-4s-9.7 1.3-9.7 4v2c0 1.8.7 3.6 2 4.9l5 4.9c.3.3.4.6.4 1v6.4c0 .4.2.7.6.8l2.9.9c.5.1 1-.2 1-.8v-7.2c0-.4.2-.7.4-1l5.1-5c1.3-1.3 2-3.1 2-4.9zm-9.7-.1c-4.8 0-7.4-1.3-7.5-1.8.1-.5 2.7-1.8 7.5-1.8s7.3 1.3 7.5 1.8c-.2.5-2.7 1.8-7.5 1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5268.4 2410.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1s-.4-1-1-1h-4.3zM5272.7 2413.7h-4.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1s-.4-1-1-1zM5272.7 2417h-4.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1 0-.5-.4-1-1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4 28.5l-8.7 10.1c-.9 1.1-2.3 1.7-3.7 1.7h-7.6c-1.4 0-2.8-.6-3.7-1.7L8.9 28.5c-1.3-1.5-3.6-1.7-5.2-.4-1.5 1.3-1.7 3.6-.4 5.2L15.2 47v30.3c0 2 1.6 3.7 3.7 3.7 2 0 3.7-1.6 3.7-3.7V62.6c0-.5.4-1 1-1h3.3c.5 0 1 .4 1 1v14.7c0 2 1.6 3.7 3.7 3.7 2 0 3.7-1.6 3.7-3.7V47L47 33.2c1.3-1.5 1.1-3.9-.4-5.2s-3.8-1.1-5.2.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2,
    cy: 28,
    r: 8.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6 33.2c1.3-1.5 1.1-3.9-.4-5.2-1.5-1.3-3.9-1.1-5.2.4l-8.7 10.2c-.9 1.1-2.3 1.7-3.7 1.7H71c-1.4 0-2.8-.6-3.7-1.7l-8.7-10.2c-1.3-1.5-3.6-1.7-5.2-.4-1.5 1.3-1.7 3.6-.4 5.2l12.5 14.5.1.1L60.9 62c-.6 1.7.7 3.5 2.5 3.5h2.2l-1.3 11.3c-.2 2 1.2 3.8 3.2 4.1 2 .2 3.8-1.2 4.1-3.2L72.9 66c0-.2.2-.4.5-.4h2.8c.2 0 .5.2.5.4L78 77.7c.2 1.9 1.8 3.2 3.6 3.2h.4c2-.2 3.5-2.1 3.2-4.1L84 65.5h2.2c1.8 0 3.1-1.8 2.5-3.5L84 47.8l.1-.1 12.5-14.5z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.8,
    cy: 28,
    r: 8.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/KIDS.f8f0d7b22ffed7736a4c6dc0d238cbd6.svg";
export { ForwardRef as ReactComponent };